var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-272b7618!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./relate.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/application/relate.vue
// module id = wMRf
// module chunks = 15